import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_NULL_GUID } from '@constants/constants';

@Pipe({
  name: 'emptyGuid',
})
export class EmptyGuidPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  public transform(value: any): string {
    if (!value || (!!value && value === DEFAULT_NULL_GUID)) {
      return this.translateService.instant('LABELS.SYSTEM');
    }
    return value;
  }
}
